function enrichProductJSON(products, callback = function() {}) {
    for (let i = 0; i < products.length; i++) updateProductJSON(products[i], callback);

    function updateProductJSON(product, callback2 = function() {}) {
        fetch(`/products/${product.handle}.js`)
            .then(response => response.json())
            .then(json => {
                if (json.requires_selling_plan !== undefined) {
                    product.is_subscription_only = json.requires_selling_plan;
                }
                if (json.selling_plan_groups !== undefined) {
                    extendProductWithSellingPlan(product, json.selling_plan_groups[0]);
                }
                let variantPrice = parseInt(product.selected_variant.price.replace(".", "") / 100),
                    subscriptionPrice = product.metafields?.og_subscription?.price,
                    subscriptionPriceDiscount = 0,
                    subscriptionPriceDiscountPercentage = 0;
                if (subscriptionPrice) {
                    subscriptionPriceDiscount = variantPrice - subscriptionPrice;
                    subscriptionPriceDiscountPercentage = parseInt(subscriptionPriceDiscount / variantPrice * 100);
                    product.selling_plan_groups[0].discount_amount = subscriptionPriceDiscount;
                    product.selling_plan_groups[0].discount_type = "fixed";
                }
                callback2();
            });
    }

    function extendProductWithSellingPlan(product, selling_plan_group) {
        if (product && selling_plan_group) {
            selling_plan_group.discount_amount = 0;
            selling_plan_group.discount_type = "none";
            for (let i = 0; i < selling_plan_group.selling_plans.length; i++) {
                const selling_plan = selling_plan_group.selling_plans[i];
                if (selling_plan_group.discount_amount == 0 && selling_plan_group.discount_type == "none" && selling_plan.price_adjustments.length > 0) {
                    let price_adjustment = selling_plan.price_adjustments[0];
                    selling_plan_group.discount_amount = price_adjustment.value;
                    selling_plan_group.discount_type = price_adjustment.value_type;
                }
                if (selling_plan.options.length > 0) {
                    let interval = getOrderIntervalForOptions(selling_plan.options[0]);
                    selling_plan.order_interval_frequency = interval.frequency;
                    selling_plan.order_interval_unit_type = interval.unit;
                }
            }
            product.selling_plan_groups = [selling_plan_group];
            selectDefaultSubscriptionFrequency(product);
        }
    }

    function getOrderIntervalForOptions(option) {
        const intervalUnits = ["day", "week", "month", "year"],
            response = {
                frequency: 1,
                unit: "day"
            };
        let frequency = option.value.toLowerCase().match(/\d+/g);
        if (frequency != null) {
            response.frequency = frequency[0];
        }
        for (let i = 0; i < intervalUnits.length; i++) {
            const unit = intervalUnits[i];
            let regex = new RegExp(unit, "g");
            if (option.value.toLowerCase().match(regex)) {
                response.unit = unit;
                break;
            }
        }
        return response;
    }
}

function selectDefaultSubscriptionFrequency(product, defaultFrequency = "30") {
    if (product.tags.split(", ").includes("3-pack")) {
        defaultFrequency = "90";
    }
    if (product.selling_plan_groups) {
        let selling_plan_group = product.selling_plan_groups[0];
        for (let i = 0; i < selling_plan_group.selling_plans.length; i++) {
            let selling_plan = selling_plan_group.selling_plans[i];
            if (selling_plan.order_interval_frequency == defaultFrequency) {
                product.subscription_id = selling_plan.id;
                product.subscription_frequency = selling_plan.order_interval_frequency;
                break;
            }
        }
    }
}

function enableSellingPlans() {
    const Rebuy = window.Rebuy,
        Shop = window.Rebuy.shop;
    if (Shop) {
        if (typeof Shop.integrations === "undefined") {
            Shop.integrations = {};
        }
        Shop.integrations.recharge = true;
        Shop.selling_plans_enabled = true;
    }
}

function setWidgetsProductType(type = "onetime") {
    const Rebuy = window.Rebuy;

    for (let i = 0; i < Rebuy.widgets.length; i++) {
        const widget = Rebuy.widgets[i];

        console.log("Widget: ", widget);

        widget.data.settings.product_type = type;
        widget.data.config.product_type = type;

        if (type === "subscription") {
            widget.data.settings.product_options.show_subscription_options = "never";
            widget.data.config.product_options.show_subscription_options = "never";
        }
    }
}

function setWidgetProductsName(products = []) {
    for (let i = 0; i < products.length; i++) {
        const product = products[i];
        if (product.subscription) {
            let planName = "Subscription";
            if (product.subscription_frequency == "1") {
                planName = "Monthly Plan";
            } else if (product.subscription_frequency == "3") {
                planName = "3 Month Plan";
            }
            product.planName = planName;
            if (!product.title.includes(planName)) {
                product.title += ` <span class="c-mini-cart__label c-mini-cart__label--weak">${product.planName}</span>`;
            }
        }
    }
}

document.addEventListener("rebuy.loaded", () => {
    enableSellingPlans();
});

document.addEventListener("rebuy.productsChange", event => {
    console.log("window.Rebuy.Cart.cartHasSellingPlanSubscriptionItems():", window.Rebuy.Cart.cartHasSellingPlanSubscriptionItems());

    if (window.Rebuy.Cart.cartHasSellingPlanSubscriptionItems()) {
        setWidgetsProductType("subscription");
    } else {
        setWidgetsProductType("subscription");
    }

    enrichProductJSON(event.detail.widget.data.products, () => {
        event.detail.widget.initProducts(event.detail.widget.data.products);
        setWidgetProductsName(event.detail.widget.data.products);
    });
});

document.addEventListener("rebuy.beforeAdd", event => {
    let product = event.detail.product,
        variant = event.detail.product.selected_variant;

    delete product.properties._quarterly_original_price;
    delete product.properties._og_subscription;
    delete product.properties._og_discount;

    if (product.subscription) {
        let isQuarterlyProduct = event.detail.product.tags.split(", ").includes("3-pack");
        product.properties._og_subscription = "true";
        if (isQuarterlyProduct && variant.compare_at_price && variant.compare_at_price > variant.price) {
            product.properties._quarterly_original_price = parseInt(variant.compare_at_price.replace(".", ""));
        }
        let subscriptionDiscount = 0;
        if (product.metafields?.og_subscription?.price) {
            subscriptionDiscount = parseInt(product.selected_variant.price - product.metafields.og_subscription.price);
        }
        product.properties._og_discount = subscriptionDiscount;
    }
});

